import { useTheme } from '@/app/ThemeContext';
import { Modal } from '@/components/Modal';
import { useModifyAccount } from '@/hooks';
import { AllIntegrations } from '@/hooks/useIntegration';
import { Account, IntegrationMeta } from '@/types';

interface SetupModalProps {
  open: boolean;
  onClose: () => void;
  onComplete: () => void;
  selectedIntegration?: Account;
  integration?: IntegrationMeta;
}

const WaitlistedModal: React.FC<SetupModalProps> = ({
  open,
  onClose,
  onComplete,
  selectedIntegration,
  integration: providedIntegration,
}) => {
  const { mutateAsync: link } = useModifyAccount('link');
  const { currentTheme } = useTheme();

  const integration =
    providedIntegration ||
    (selectedIntegration
      ? AllIntegrations[
          selectedIntegration.member as keyof typeof AllIntegrations
        ]
      : undefined);

  if (!integration) return null;

  const handleSetupLater = async () => {
    await link({
      username: integration.id,
      value: 'waitlisted',
      config: {},
    });

    onComplete();
    onClose();
  };

  const footerConfig = integration.hideFooter
    ? undefined
    : {
        text: 'Notify & Add to Dashboard',
        onClick: () => {
          handleSetupLater();
        },
      };

  const description = integration.hideFooter ? (
    <p className="mb-6">{integration.description}</p>
  ) : (
    'This integration is currently unavailable. To make it available, let us know you want it by clicking the button below, and we will notify you when it’s ready to connect.'
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="lg"
      title={
        <div className="flex w-full flex-row justify-between">
          <p>{integration.name} Setup</p>
          <img
            src={`/icons/${currentTheme}/${integration.logo}`}
            alt={integration.name}
            className="size-6"
          />
        </div>
      }
      hideFooter={integration.hideFooter}
      footer={footerConfig}
    >
      <p className="mt-0 text-sm">{description}</p>
    </Modal>
  );
};

export default WaitlistedModal;
